"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataImportPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const HelpBlock_1 = tslib_1.__importDefault(require("../../components/HelpBlock"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../components/SimpleButton"));
const PopupPanel_1 = require("../Components/Popups/AdaptablePopup/PopupPanel");
const DataImportWizard_1 = require("./DataImportWizard");
const DataImportPopup = (props) => {
    const [isWizardOpen, setIsWizardOpen] = React.useState(false);
    React.useEffect(() => {
        var _a, _b;
        if (((_a = props.popupParams) === null || _a === void 0 ? void 0 : _a.action) === 'New' && ((_b = props.popupParams) === null || _b === void 0 ? void 0 : _b.source) !== 'ModuleMenu') {
            setIsWizardOpen(true);
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PopupPanel_1.PopupPanel, { headerText: 'Data Import', glyphicon: 'import', infoLink: props.moduleInfo.HelpPage },
            React.createElement(rebass_1.Box, null,
                React.createElement(HelpBlock_1.default, { mb: 2, fontSize: 3 }, "Click the 'Import Data' button to Insert or Update data into AdapTable"),
                React.createElement(SimpleButton_1.default, { icon: "import", variant: "raised", onClick: () => setIsWizardOpen(true) }, "Import Data"))),
        isWizardOpen && (React.createElement(DataImportWizard_1.DataImportWizard, { onClose: () => {
                var _a;
                setIsWizardOpen(false);
                if (['Toolbar', 'ContextMenu', 'ColumnMenu', 'ModuleButton'].includes((_a = props === null || props === void 0 ? void 0 : props.popupParams) === null || _a === void 0 ? void 0 : _a.source)) {
                    props.onClosePopup();
                }
            } }))));
};
exports.DataImportPopup = DataImportPopup;
